"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _iconButton = _interopRequireDefault(require("../icon-button"));
var _close = _interopRequireDefault(require("../../icons/close"));
require("./close-button.css");
var _excluded = ["alignment", "className", "highContrast"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * A close button for use in modals, overlays, bottom sheets, and similar. Includes
 * two alignment presets anchoring the button to the top right or top left of a
 * relative container.
 *
 * For more complex layouts, you can ignore the alignment prop to render the component
 * without any positioning build in, allowing you to provide your own.
 */
var CloseButton = function CloseButton(_ref) {
  var alignment = _ref.alignment,
    className = _ref.className,
    highContrast = _ref.highContrast,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_iconButton["default"], _extends({
    className: (0, _classnames["default"])('sb-closeButton', _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, className, Boolean(className)), "absolute", Boolean(alignment)), 'sb-closeButton--right', alignment === 'right'), 'sb-closeButton--left', alignment === 'left')),
    highContrast: highContrast,
    path: _close["default"]
  }, otherProps));
};
CloseButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Optional right or left alignment to pull the close button to the top right or top left edge
   * of its container, using absolute positioning.
   */
  alignment: _propTypes["default"].oneOf(['right', 'left']),
  className: _propTypes["default"].string,
  /**
   * `aria-label` applied to button.
   */
  ariaLabel: _propTypes["default"].string.isRequired,
  /**
   * optional prop to allow button to be seen more easily on dark backgrounds
   */
  highContrast: _propTypes["default"].bool
} : {};
CloseButton.displayName = 'CloseButton';
var _default = exports["default"] = CloseButton;